<global-nav
  [appLabel]="'Control'"
  [prezUrl]="navbarService.PREZ_URL"></global-nav>
<mat-sidenav-container class="mat-container" autosize>
  <mat-sidenav mode="side" opened #drawer
               #sidenav
               id="sidenav"
               [class.menu-open]="isMenuOpen"
               [class.menu-close]="!isMenuOpen">
    <app-side-nav [isCollapsed]="isCollapsed" [appName]="appName" [drawer]="drawer" [isMenuOpen]="isMenuOpen"
                  (isMenuOpenChange)="updateSideNav($event)"
                  [navComponents]="['site', 'program', 'control']"></app-side-nav>
  </mat-sidenav>
  <mat-sidenav-content>
    <main role="main" class="container-fluid">
      <router-outlet></router-outlet>
      <app-toasts></app-toasts>
    </main>
  </mat-sidenav-content>
</mat-sidenav-container>
